import { Link } from 'react-router-dom'

interface MenuItemProps {
  icon: React.ReactNode
  name?: string
  to: string
  tip?: string
  active: boolean
}

export const MenuItem = (props: MenuItemProps) => {
  const { icon, name, to, active } = props

  return (
    <Link
      className={`menu ${active && 'menu-active'}`}
      style={{
        textDecoration: 'none',
        display: 'flex',
        flex: 'auto',
        justifyItems: 'center',
        cursor: 'pointer',
        color: '#262626',
        width: 'auto'
      }}
      to={to}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }}
      >
        {icon}
        <div
          className="menu-text"
          style={{
            paddingLeft: 12,
            fontWeight: 500
          }}
        >
          {name}
        </div>
      </div>
    </Link>
  )
}
